import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function Login({ onSuccess }) {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(`${API_URL}/auth/login`, { username, password });
      onSuccess(response.data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Sign-in failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={handleSubmit}>
        <p className="login-kicker">Private console</p>
        <h1>Atelier CDN</h1>
        <p className="login-copy">Sign in to manage libraries. Public image URLs stay unchanged.</p>
        {error && <p className="login-error">{error}</p>}
        <label>
          Username
          <input
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoFocus
          />
        </label>
        <button type="submit" className="btn btn-accent btn-block" disabled={loading}>
          {loading ? 'Signing in…' : 'Enter'}
        </button>
      </form>
    </div>
  );
}

export default Login;
